import AppDispatcher from '../utils/AppDispatcher';
import { EventEmitter } from 'events';

import { actions as UserActionConstants } from '../constants/UserConstants';
import UserActions from '../actions/UserActions';
import { actions as AuthActions } from '../constants/AuthConstants';

import { events as UserEvents } from '../constants/UserConstants';
import GuestListStore from './GuestListStore';
import ConfigStore from './ConfigStore';
import LogRocket from 'logrocket';

var _state = {
    user: false,

    locations: false,
    selectedLocation: false,

    registers: false,
    selectedRegister: false,

    rooms: [],
    selectedRoom: '-',
    selectedRoomArr: [],
    customerTypes: [],

    status: [],

    timeOffset: 0,

    validDPHCredentials: true,
    ldFlags: {},
};

let FieldOption = {
    Show: 1,
    Required: 2,
    Hide: 3,
};

class UserStoreClass extends EventEmitter {

    getState() {
        return _state;
    }

    getCartHasRounding() {
        return _state.selectedLocation.RoundDownToQuarter
            || _state.selectedLocation.RoundDownToDollar
            || _state.selectedLocation.RoundPercentDiscounts
            || _state.selectedLocation.RoundToNearestNickel
            || _state.selectedLocation.RoundToNearestDollar
            || _state.selectedLocation.RoundDownToNearestFiver
            || _state.selectedLocation.CurbsideRoundDownToNearestFiver;
    }

    setRegister(registerId) {
        _state.selectedRegister = {
            id: registerId,
        };
    }

    getApiData(formData) {
        if (!formData) {
            formData = {};
        }

        formData.SessionId = (_state.user.sessionId || '').toString();
        formData.LspId = (_state.user.LspId || '').toString();

        if (!formData.hasOwnProperty('LocId'))
            formData.LocId = _state.selectedLocation ? _state.selectedLocation.location_id : 0;

        formData.Register = _state.selectedRegister ? _state.selectedRegister.id : 0;
        formData.UserId = _state.user.userId;

        return formData;
    }

    getRoomId() {
        if (_state.selectedRoom === '-') {
            return false;
        }

        for (var i=0; i<_state.rooms.length; i++) {
            if (_state.selectedRoom === _state.rooms[i].RoomName) {
                return _state.rooms[i].RoomId;
            }
        }
    }

    isFieldRequired(FormName, FieldName) {
        var field = _state.validatedForms.filter(x => x.FormName.toUpperCase() == FormName.toUpperCase()
            && (x.ReactName.toUpperCase() == FieldName.toUpperCase() || x.DisplayName.toUpperCase() == FieldName.toUpperCase()));

        if (field[0]) {
            return field[0].CustomerOption == FieldOption.Required || field[0].SystemRequired;
        }
        return false;
    }

    isFieldHidden(FormName, FieldName) {
        var field = _state.validatedForms.filter(x => x.FormName.toUpperCase() == FormName.toUpperCase()
            && x.ReactName.toUpperCase() == FieldName.toUpperCase());

        if (field[0]) {
            return field[0].CustomerOption == FieldOption.Hide;
        }
        return false;
    }

    getFormError(FormName, Form) {
        for (var Field in Form) {
            var value = Form[Field];

            if (this.isFieldRequired(FormName, Field)) {
                if (!value || (typeof value == 'string' && value.toUpperCase() == 'N/A')) {
                    return Field + ' is required';
                }

                if (value == 0) {
                    return Field + ' Cannot be 0';
                }

                if (typeof value === 'string' && !value.trim()) {
                    return Field + ' cannot be blank';
                }
            }
        }
        return false;
    }

    emitChange(callback) {
        this.emit(UserEvents.CHANGE_EVENT, callback);
    }

    addChangeListener(callback) {
        this.on(UserEvents.CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(UserEvents.CHANGE_EVENT, callback);
    }
}

const UserStore = new UserStoreClass();

UserStore.dispatchToken = AppDispatcher.register(action => {

    switch (action.actionType) {

    case AuthActions.LOGIN:
        if (action.data) {
            _state.user = action.data;
            _state.locations = _.sortBy(action.data.locations, 'location_name');

            if (_state.locations.length === 1 && !action.skipRedirect) {
                Promise.resolve().then(() => {
                    UserActions.selectLocation(_state.locations[0]);
                    GuestListStore.setPage('register');
                });
            }

            try {
                var FullStory = window.FS || {};
                FullStory.identify(action.data.userId, {
                    displayName: action.data.FullName,
                    email: action.data.UserName,
                });

            }
            catch (ex) {
                console.warn(ex);
            }

            try {
                LogRocket.identify(action.data.userId, {
                    displayName: action.data.FullName,
                    email: action.data.UserName,
                });
            } catch (ex) {
                console.warn(ex);
            }

            try {
                const pendo = window.pendo || {};
                pendo.initialize({
                    visitor: {
                        id: action.data.UserId,
                        email: action.data.UserName,
                        full_name: action.data.FullName,
                        LocId: action.data.LocId,
                        LspId: action.data.LspId,
                        Deployment: ConfigStore.getRegion(),
                        location_id_and_region: `${action.data.LocId}${ConfigStore.getRegion()}`,
                    },
                    account: {
                        id: action.data.LocId,
                    },
                });
            } catch (error) {
                    // eat it
            }

            UserStore.emitChange();
        }
        break;
    case AuthActions.LOGOUT:
        _state.user = false;
        _state.locations = false;
        UserStore.emitChange();
        break;

    case UserActionConstants.SELECT_LOCATION:
        _state.rooms = _.sortBy(action.data.rooms, 'RoomName');
        _state.timeOffset = action.data.timeOffset;
        _state.selectedLocation = action.data.selectedLocation;
        _state.validatedForms = action.data.validatedForms;

        _state.registers = action.data.registers;
        _state.selectedRegister = false;
        _state.customerTypes = action.data.customerTypes;
        _state.ldFlags = action.data.ldFlags;

        if (_state.registers.length === 1) {
            Promise.resolve().then(() => {
                UserActions.selectRegister(_state.registers[0]);
                GuestListStore.setPage('list');
            });
        } else {
            GuestListStore.setPage('register');
        }

        UserStore.emitChange();
        break;

    case UserActionConstants.REGISTER_SELECTED:
        _state.selectedRegister = action.data;
        UserStore.emitChange();
        break;

    case UserActionConstants.ROOM_SELECTED:
        _state.selectedRoom = action.data;
        UserStore.emitChange();
        break;

    case UserActionConstants.ROOM_ARR_SELECTED:
        var arr = _state.selectedRoomArr;
        var match = arr.indexOf(action.data);

        if (match === -1) {
            arr.push(action.data);
        } else {
            arr = arr.filter(x => {
                return x !== action.data;
            });
        }

        _state.selectedRoomArr = arr;
        UserStore.emitChange();
        break;

    case UserActionConstants.ROOM_ARR_CLEAR:
        _state.selectedRoomArr = [];
        UserStore.emitChange();
        break;

    case UserActionConstants.ROOMS_LOADED:
        _state.rooms = action.data;
        UserStore.emitChange();
        break;

    case UserActionConstants.TOGGLE_DPH_CREDENTIALS:
        _state.validDPHCredentials = action.data;
        UserStore.emitChange();
        break;
    }
});

export default UserStore;



// WEBPACK FOOTER //
// ./ui_src/app/stores/UserStore.jsx